import { ChevronRight } from 'lucide-react';

// iOS inset-grouped list section: gray uppercase header + white rounded card of rows.
export function ListSection({ title, children, footer }) {
  return (
    <section className="px-4 mt-6">
      {title && (
        <h3 className="text-[13px] font-normal uppercase text-[#6D6D72] px-4 pb-1.5 tracking-wide">
          {title}
        </h3>
      )}
      <div className="bg-white rounded-xl overflow-hidden divide-y divide-black/[0.06]">
        {children}
      </div>
      {footer && (
        <p className="text-[13px] text-[#6D6D72] px-4 pt-1.5">{footer}</p>
      )}
    </section>
  );
}

// iOS list row: optional leading icon badge, label column, trailing value + chevron.
export function ListRow({ icon: Icon, iconBg = '#FF3B30', title, subtitle, value, onClick, chevron = true, destructive = false }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-4 py-3 min-h-[44px] text-left ${onClick ? 'active:bg-gray-100 transition-colors' : ''}`}
    >
      {Icon && (
        <span
          className="w-[30px] h-[30px] rounded-[7px] flex items-center justify-center shrink-0"
          style={{ backgroundColor: iconBg }}
        >
          <Icon size={17} className="text-white" />
        </span>
      )}
      <span className="flex-1 min-w-0">
        <span className={`block text-[16px] truncate ${destructive ? 'text-[#FF3B30]' : 'text-gray-900'}`}>
          {title}
        </span>
        {subtitle && <span className="block text-[13px] text-[#6D6D72] truncate">{subtitle}</span>}
      </span>
      {value && <span className="text-[15px] text-[#8E8E93] shrink-0">{value}</span>}
      {onClick && chevron && <ChevronRight size={17} className="text-[#C7C7CC] shrink-0" />}
    </Tag>
  );
}
